var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Facebook",
    width: 24,
    height: 24,
    "data-name": "Icon - Facebook",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0h24v24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Facebook-2",
    "data-name": "Icon - Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0h9v16H0z",
    className: "prefix__cls-1",
    transform: "translate(7 4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__icons8-facebook-f-filled",
    fill: "#4666ae",
    d: "M18.923 5.13h1.731A.347.347 0 0 0 21 4.783V2.439a.346.346 0 0 0-.32-.347C20.129 2.053 19.053 2 18.28 2a3.272 3.272 0 0 0-3.51 3.606v2.307h-2.424a.347.347 0 0 0-.346.348V10.7a.347.347 0 0 0 .346.348h2.423v6.609a.347.347 0 0 0 .346.348h2.423a.347.347 0 0 0 .346-.348v-6.614h2.5a.347.347 0 0 0 .344-.31L21 8.3a.347.347 0 0 0-.344-.386h-2.771v-1.74a1.041 1.041 0 0 1 1.038-1.044z",
    transform: "translate(-5 2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.98e9a18fb6461a32cca436ac8d05303a.svg";
export { ForwardRef as ReactComponent };